import React, { useEffect, useState } from "react";

//api
import api from "../services/api";

//react-router-dom
import {
  useNavigate
} from "react-router-dom";

import LoadingRipple from "../svgs/LoadingRipple";

export const AuthContext = React.createContext({});

export const AuthProvider = (props) => {
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const [user, setUser] = React.useState({
    id: "",
    name: "",
    token: ""
  });

  async function verifyGroup(id) {
    try {
      const response = await api.get("/verify/group?group_id=" + id);

      return response.data.authorization;
    } catch (err) {
      setUser({ id: "", name: "", token: "" });
      localStorage.removeItem("user");
      navigate("/", { replace: true });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const verify = async () => {
      const userStorage = localStorage.getItem("user");

      if (userStorage) {
        const user = JSON.parse(userStorage);

        if (await verifyGroup(user.group_id)) {
          setUser(user);
        } else {
          setUser({ id: "", name: "", token: "" });
          localStorage.removeItem("user");
          navigate("/", { replace: true });
          setLoading(false);
        }

      } else {
        setLoading(false);
        setUser({ id: "", name: "", token: "" });
      }
    }

    verify();
  }, []);

  if (loading) return <div className="loading__ripple">
    <LoadingRipple/>
  </div>;

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {props.children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => React.useContext(AuthContext);